import Swal from 'sweetalert2';

// Configuración por defecto para SweetAlert2
const defaultConfig = {
  confirmButtonColor: '#3085d6',
  cancelButtonColor: '#d33',
  confirmButtonText: 'Sí',
  cancelButtonText: 'Cancelar'
};

// Reemplazo para window.confirm
export const showConfirm = async (message: string, title?: string): Promise<boolean> => {
  const result = await Swal.fire({
    title: title || '¿Estás seguro?',
    text: message,
    icon: 'warning',
    showCancelButton: true,
    ...defaultConfig
  });
  
  return result.isConfirmed;
};

// Reemplazo para window.alert
export const showAlert = async (message: string, title?: string, icon: 'success' | 'error' | 'warning' | 'info' = 'info'): Promise<void> => {
  await Swal.fire({
    title: title || 'Información',
    text: message,
    icon: icon,
    confirmButtonText: 'OK',
    confirmButtonColor: '#3085d6'
  });
};

// Alert de éxito
export const showSuccess = async (message: string, title?: string): Promise<void> => {
  await showAlert(message, title || '¡Éxito!', 'success');
};

// Alert de error
export const showError = async (message: string, title?: string): Promise<void> => {
  await showAlert(message, title || 'Error', 'error');
};

// Alert de advertencia
export const showWarning = async (message: string, title?: string): Promise<void> => {
  await showAlert(message, title || 'Advertencia', 'warning');
};